import {
  RawConceptData,
  RawSubjectToConceptData,
} from "../../Concepts.interface";

// This function gets the first five ELA tags from the taxonomy data we
// get back from our tanstack query.
export const getTopFiveTags = (rawTaxonomyData: RawSubjectToConceptData) => {
  if (!Object.values(rawTaxonomyData)[0]) return [];

  const firstSubjectDataGroup = Object.values(rawTaxonomyData)[0].items;

  const rootId = Object.keys(firstSubjectDataGroup).find(
    (id) =>
      (firstSubjectDataGroup[id] as RawConceptData).data.object_type ===
      "Document",
  );

  if (!rootId) return [];

  const firstLevelChildren = firstSubjectDataGroup[rootId]?.children ?? [];
  const childNodes = firstLevelChildren.map(
    (id: string) => firstSubjectDataGroup[id],
  );

  return childNodes.slice(0, 5).map((node: RawConceptData) => ({
    id: node.index,
    name: node.data.name,
    description: node.data.description || "",
    parentId: node.data.parent,
    isFolder: node.isFolder,
    children: node.children,
  }));
};
